import { onMounted, computed, ref } from 'vue'
import { useStore } from 'vuex'
import FileListCard from 'components/FileListCard/FileListCard.vue'

export default {
    name: "DocumentAndFolderList",    
    components: { 
        FileListCard  
    },
    props: {
        guid: {
            type: String,
            required: true
        },
        cardButtonIcons: {
            type: Object,
            required: true,
            default: false
        },
        gruppeKode: {
            type: String,
            required: true
        },
        fileTypeDropdownOptions : {
            type: Object,
            required: true
        }
    },
    setup(props) {
        const store = useStore()

        const isSearching = computed(()=> store.state.search.is_searching)

        const mappeName = ref(null)
        const parentMappeName = ref(null)
        const parentMappeUrl = ref(null)

        const hasParentMappe = computed(() => !!parentMappeName.value)

        const getLabel = (labelKey) => store.getters['labels/getLabel']({ labelCollection: "DocumentAndFolderList", labelKey: labelKey })

        const startOverlayFunction = function (e, overlay) {
            if(overlay === 'CreateFolderOverlay') {
                // the active overlay mode should be set when overlay activated
                // when overlay closed, mode is cleared inside pageOverlay.options
                store.dispatch('frivillige/setActiveOverlayMode', { mode: "Mappe" }) 
                //editModeActive should also be updated
                store.dispatch('frivillige/setEditModeActive', { mode: false })  
                
                store.dispatch('main/openPageOverlay',{
                            overlayContent: overlay,
                            returnTarget: e.currentTarget
                })
            } else {
                store.dispatch('frivillige/setActiveOverlayMode', { mode: "Dokument" })  
                
                store.dispatch('main/openPageOverlay',{
                            overlayContent: overlay,
                            returnTarget: e.currentTarget
                })
            }              

        }

        const files = computed(() => store.state.search.results[props.guid] )

        onMounted(() => {
            initFetchPosts()
            store.commit('frivillige/set_file_type_dropdown_options', props.fileTypeDropdownOptions)
        })

        const initFetchPosts = function() {

            store.commit('search/set_replaceQueryInUrl', false)
    
            store.dispatch('search/initSearchScope', {
                guid: props.guid,
                firstPageSize: props.take,
                showMorePageSize: props.take,
                url: process.env.GET_FILES_LIST.replace('[gruppeKode]', props.gruppeKode)
            })
            
            store.dispatch("frivillige/setGlobalGruppeKode", {
                gruppeKode: props.gruppeKode
            });
     
            store.dispatch('search/performSearch', {
                guid: props.guid,
                query: ''
            })
            .then((json) =>{
                mappeName.value = json.mappeName
                parentMappeName.value = json.parentMappeName
                parentMappeUrl.value = json.parentMappeUrl
            })

        }

        return {
            mappeName,
            parentMappeName,
            parentMappeUrl,
            hasParentMappe,
            getLabel,
            startOverlayFunction,
            files,
            isSearching    
        }
    }
}